/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CohortTypeEnum } from '../models/cohort-type-enum';
import { CompanyRefDto } from '../models/company-ref-dto';

@Injectable({
  providedIn: 'root',
})
export class CohortService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCohort
   */
  static readonly GetCohortPath = '/cohorts/{cohort}';

  /**
   * Get cohort.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCohort()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCohort$Response(params: {
    cohort: CohortTypeEnum;
    pageIndex?: number;
    pageSize: number;
  }): Observable<StrictHttpResponse<Array<CompanyRefDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CohortService.GetCohortPath, 'get');
    if (params) {
      rb.path('cohort', params.cohort, {});
      rb.query('pageIndex', params.pageIndex, {});
      rb.query('pageSize', params.pageSize, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CompanyRefDto>>;
      })
    );
  }

  /**
   * Get cohort.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCohort$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCohort(params: {
    cohort: CohortTypeEnum;
    pageIndex?: number;
    pageSize: number;
  }): Observable<Array<CompanyRefDto>> {

    return this.getCohort$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CompanyRefDto>>) => r.body as Array<CompanyRefDto>)
    );
  }

  /**
   * Path part for operation updateCohort
   */
  static readonly UpdateCohortPath = '/cohorts/{cohort}';

  /**
   * Update cohort.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCohort()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCohort$Response(params: {
    cohort: CohortTypeEnum;
    body: Array<CompanyRefDto>
  }): Observable<StrictHttpResponse<{
'companiesNotFound'?: Array<string>;
}>> {

    const rb = new RequestBuilder(this.rootUrl, CohortService.UpdateCohortPath, 'put');
    if (params) {
      rb.path('cohort', params.cohort, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'companiesNotFound'?: Array<string>;
        }>;
      })
    );
  }

  /**
   * Update cohort.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateCohort$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCohort(params: {
    cohort: CohortTypeEnum;
    body: Array<CompanyRefDto>
  }): Observable<{
'companiesNotFound'?: Array<string>;
}> {

    return this.updateCohort$Response(params).pipe(
      map((r: StrictHttpResponse<{
'companiesNotFound'?: Array<string>;
}>) => r.body as {
'companiesNotFound'?: Array<string>;
})
    );
  }

  /**
   * Path part for operation deleteCohort
   */
  static readonly DeleteCohortPath = '/cohorts/{cohort}';

  /**
   * Delete cohort.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCohort()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteCohort$Response(params: {
    cohort: CohortTypeEnum;
    body: Array<CompanyRefDto>
  }): Observable<StrictHttpResponse<{
'companiesNotFound'?: Array<string>;
}>> {

    const rb = new RequestBuilder(this.rootUrl, CohortService.DeleteCohortPath, 'delete');
    if (params) {
      rb.path('cohort', params.cohort, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'companiesNotFound'?: Array<string>;
        }>;
      })
    );
  }

  /**
   * Delete cohort.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteCohort$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteCohort(params: {
    cohort: CohortTypeEnum;
    body: Array<CompanyRefDto>
  }): Observable<{
'companiesNotFound'?: Array<string>;
}> {

    return this.deleteCohort$Response(params).pipe(
      map((r: StrictHttpResponse<{
'companiesNotFound'?: Array<string>;
}>) => r.body as {
'companiesNotFound'?: Array<string>;
})
    );
  }

}
